module.exports = __webpack_public_path__ + "img/si.797067a4.png";